const CUSTOMER_EXCHANGE_BANK_WORKFLOW = {
  ENVIADO_AO_BANCO: {
    id: 1,
    description: 'Enviado ao banco',
    icon: 'PhBank',
    method: 'updateStatusToSentToBank',
    next: () => {
      return [CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_PRE_APROVADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.PENDECIA, CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_INATIVADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_RECUSADO,CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_APROVADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.BLOQUEADO];
    },
  },
  PENDECIA: {
    id: 2,
    description: 'Pendência junto ao banco',
    icon: 'PhWarning',
    method: 'updateStatusToPendency',
    next: () => {
      return [CUSTOMER_EXCHANGE_BANK_WORKFLOW.PENDECIA, CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_PRE_APROVADO ,CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_APROVADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_INATIVADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_RECUSADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.ENVIADO_AO_BANCO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.BLOQUEADO];
    },
  },
  CADASTRO_PRE_APROVADO: {
    id: 3,
    description: 'Cadastro pré aprovado',
    icon: 'PhCheckCircle',
    method: 'updateStatusToPreApproved',
    next: () => {
      return [CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_APROVADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_INATIVADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_RECUSADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.BLOQUEADO];
    },
  },
  CADASTRO_APROVADO: {
    id: 4,
    description: 'Cadastro aprovado',
    icon: 'PhCheckCircle',
    method: 'updateStatusToApproved',
    next: () => {
      return [CUSTOMER_EXCHANGE_BANK_WORKFLOW.AGUARDANDO_ASSINATURA, CUSTOMER_EXCHANGE_BANK_WORKFLOW.ENVIADO_AO_BANCO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.BLOQUEADO];
    },
  },
  CADASTRO_INATIVADO: {
    id: 5,
    description: 'Cadastro inativado',
    icon: 'PhMinusCircle',
    method: 'updateStatusToInactivated',
    next: () => {
      return [CUSTOMER_EXCHANGE_BANK_WORKFLOW.AGUARDANDO_ASSINATURA, CUSTOMER_EXCHANGE_BANK_WORKFLOW.ENVIADO_AO_BANCO];
    },
  },
  CADASTRO_RECUSADO: {
    id: 6,
    description: 'Cadastro recusado',
    icon: 'PhXCircle',
    method: 'updateStatusToRejected',
    next: () => {
      return [CUSTOMER_EXCHANGE_BANK_WORKFLOW.AGUARDANDO_ASSINATURA, CUSTOMER_EXCHANGE_BANK_WORKFLOW.ENVIADO_AO_BANCO];
    },
  },
  AGUARDANDO_ASSINATURA: {
    id: 12,
    description: 'Aguardando assinatura',
    icon: 'PhPencilSimple',
    method: null,
    next: () => {
      return [CUSTOMER_EXCHANGE_BANK_WORKFLOW.ENVIADO_AO_BANCO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_INATIVADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_RECUSADO, CUSTOMER_EXCHANGE_BANK_WORKFLOW.BLOQUEADO];
    },
  },
  BLOQUEADO: {
    id: 7,
    description: 'Bloqueado',
    icon: 'PhLock',
    method: 'updateStatusToBlocked',
    next: () => {
      return [CUSTOMER_EXCHANGE_BANK_WORKFLOW.ENVIADO_AO_BANCO];
    },
  },
}

const CUSTOMER_EXCHANGE_BANK_WORKFLOW_LIST = Object.values(CUSTOMER_EXCHANGE_BANK_WORKFLOW);

// Export para ES modules (frontend)
export  {
  CUSTOMER_EXCHANGE_BANK_WORKFLOW,
  CUSTOMER_EXCHANGE_BANK_WORKFLOW_LIST,
}

// Export para CommonJS (backend) - apenas se module estiver disponível
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    CUSTOMER_EXCHANGE_BANK_WORKFLOW,
    CUSTOMER_EXCHANGE_BANK_WORKFLOW_LIST,
  };
}
